module.exports = __webpack_public_path__ + "img/why-need-loan-image.ee4b60b5.png";